// src/hooks/useDeviceId.js
import { useEffect, useState } from 'react';
import  getOrCreateDeviceId  from '../lib/fingerprint';

export function useDeviceId() {
  const [deviceId, setDeviceId] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const id = await getOrCreateDeviceId();
      if (mounted) setDeviceId(id);
    })();
    return () => { mounted = false; };
  }, []);

  return deviceId;
}
